// src/components/Layout.js (Versión Completa y Funcional con Búsqueda)
import React, { useState } from 'react';
import { 
  Box, 
  Drawer, 
  List, 
  ListItem, 
  ListItemButton, 
  ListItemIcon, 
  ListItemText, 
  Toolbar, 
  AppBar, 
  Typography, 
  Button,
  TextField,
  InputAdornment
} from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import BusinessIcon from '@mui/icons-material/Business';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSearch } from '../context/SearchContext';
import SearchResultDialog from './SearchResultDialog'; // Importamos el diálogo de resultados

const drawerWidth = 240;

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const auth = useAuth();
  const { performSearch } = useSearch();
  const [searchText, setSearchText] = useState('');

  const handleLogout = () => {
    auth.logout();
    navigate('/login');
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchText.trim()) {
      performSearch(searchText.trim());
      setSearchText(''); // Opcional: limpiar la barra después de buscar
    }
  };

  const menuItems = [
    { text: 'Street Ranges', icon: <MapIcon />, path: '/dashboard/street-ranges' },
    { text: 'Firms', icon: <BusinessIcon />, path: '/dashboard/firms' },
  ];

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            PackageRoute Admin
          </Typography>
          
          <Box component="form" onSubmit={handleSearchSubmit} sx={{ mr: 2 }}>
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search Address..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                sx: {
                  backgroundColor: 'rgba(255, 255, 255, 0.15)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.25)',
                  },
                }
              }}
            />
          </Box>

          <Button color="inherit" onClick={handleLogout}>Log Out</Button>
        </Toolbar>
      </AppBar>
      
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto' }}>
          <List>
            {menuItems.map((item) => (
              <ListItem key={item.text} disablePadding>
                <ListItemButton onClick={() => navigate(item.path)}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
      
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        {children}
      </Box>
      
      <SearchResultDialog />
    </Box>
  );
};

export default Layout;
